import "./App.css";
import Header from "./components/Header/Header";
import TypingWindow from "./components/TypingWindow/TypingWindow";

function App() {
  return (
    <div className="App">
      <Header />
      <TypingWindow />
    </div>
  );
}

export default App;
